import { Component, inject } from '@angular/core';
import * as XLSX from 'xlsx';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AWSLambda } from '../../../AWSLambda.service';

@Component({
  selector: 'app-esim-catalog',
  templateUrl: './esim-catalog.component.html',
  styleUrls: ['./esim-catalog.component.scss']
})
export class EsimCatalogComponent {
  private lambda = inject(AWSLambda);
  private snackBar = inject(MatSnackBar);

  isLoading = false;

  async downloadCatalog(): Promise<void> {
    this.isLoading = true;
    try {
      const data: any[] = await this.lambda.getLambdaFunction('lambda', '/esim/airaloGetPackages', {
        queryStringParameters: { mode: 'export' }
      });

      const rows = data
        .sort((a, b) => {
          const countryDiff = a.country.localeCompare(b.country, 'es');
          return countryDiff !== 0 ? countryDiff : a.our_price - b.our_price;
        })
        .map(item => ({
          'País': item.country,
          'Código eSIM': item.id_pkg,
          'Precio neto (coste)': item.net_price,
          'Precio venta': item.our_price,
        }));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Catálogo eSIM');

      const xlsxContent = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([xlsxContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `catalogo_esim_${new Date().toISOString().slice(0, 10)}.xlsx`;
      anchor.click();
      window.URL.revokeObjectURL(url);

      this.snackBar.open(`Catálogo descargado: ${rows.length} paquetes`, 'OK', { duration: 4000 });
    } catch (err: any) {
      console.error('Error descargando catálogo eSIM:', err);
      const msg = err?.message?.includes('403') ? 'Acceso denegado: se requiere superAdmin' : 'Error al obtener el catálogo';
      this.snackBar.open(msg, 'Cerrar', { duration: 5000 });
    } finally {
      this.isLoading = false;
    }
  }
}
